import {
    accountSourceDataTypeChecker,
    getGlobalSettingsAccount,
    getMailAccountSources,
} from 'owa-account-source-list-store';
import type { M365AccountSource } from 'owa-account-source-list-store';
import { MailFolderTreesParentContainer } from 'owa-mail-folder-tree-container-view';
import TreeNode from 'owa-tree-node/lib/components/TreeNode';
import * as React from 'react';
import styles from './AccountsList.scss';

export const GlobalSettingsAccountFolderNodeWithDummyList = function GlobalSettingsAccountFolderNodeWithDummyList() {
    const accountSources = getMailAccountSources();
    const globalSettingsAccountSource = getGlobalSettingsAccount();

    return (
        <>
            <MailFolderTreesParentContainer
                isFavoriteOrGroupListShown={true}
                leftNavStyleWithSectionHeaders={styles.leftNavSectionWithSectionHeaders}
                leftNavStyleWithNoSectionHeaders={styles.leftNavSectionWithNoSectionHeaders}
                setSize={0}
                positionInSet={0}
                primarySmtp={
                    accountSourceDataTypeChecker.isM365Mailbox(globalSettingsAccountSource)
                        ? globalSettingsAccountSource.m365mailbox.emailAddress
                        : undefined
                }
                showRootNode={true}
            />

            {accountSources
                .filter(
                    accountSource =>
                        accountSourceDataTypeChecker.isM365Mailbox(accountSource) &&
                        accountSource.sourceId !== globalSettingsAccountSource.sourceId
                )
                .map(accountSource => (
                    <TreeNode
                        displayName={(accountSource as M365AccountSource).m365mailbox.emailAddress}
                        depth={0}
                        isRootNode={true}
                        key={accountSource.sourceId}
                        isDroppedOver={false}
                    />
                ))}
        </>
    );
};
